import { AxiosError, AxiosResponse } from "axios";
import Feed from "components/feed";
import FormCondition from "components/form-condition";
import Separate from "components/separate";
import IconInfo from "icons/icon-info/icon-info";
import icAdsCommerce from "images/ic_ads_commerce.svg";
import NotFound from "pages/not-found";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import api, { IResponse } from "services/http-common";
import { campaignInfoState, isCompletedState, zoomState } from "state";
import formatCurrency from "utils/formatCurrency";
import { FeedItem } from "ztypes/feed";
import { FeedAds } from "ztypes/feed-ads";

const LandingPage: React.FC<{}> = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const fid: number = Number(searchParams.get("fid") || 0);

  const zoom = useRecoilValue(zoomState);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isCompleted, setIsCompleted] = useRecoilState(isCompletedState);
  const [feedItem, setFeedItem] = useState<FeedItem>();

  const [campaignInfo, setCampainInfo] = useRecoilState(campaignInfoState);

  const handlePayment = () => {
    if (!isCompleted) {
      return;
    }
    api
      .post<AxiosResponse<any>>(`/payment`, campaignInfo)
      .then((resp) => {
        if (resp.data && resp.data.data.payUrl) {
          window.location.href = resp.data.data.payUrl;
        } else {
          navigate("/nf");
        }
      })
      .catch((e) => {
        navigate("/nf");
      });
  };

  useEffect(() => {
    api
      .get<IResponse>(`/feed`, {
        params: { fid: fid },
      })
      .then((resp) => {
        if (!resp || resp.status != 200 || !resp.data) {
          navigate("/nf");
        } else if (resp.data.error_code == -1) {
          navigate(`/upgrade-zba${window.location.search}`);
        }
        setIsLoading(false);
        const data: FeedAds = resp.data.data;
        if (data) {
          setIsCompleted(data.isCompleted);
          setFeedItem(data.feed);
          const dataCampain = data.campaignInfo;
          if (dataCampain) {
            setCampainInfo(dataCampain);
          } else {
            setCampainInfo((currState) => ({
              ...currState,
              fid: fid,
            }));
          }
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  }, []);
  useEffect(() => {}, [isLoading]);

  if (isLoading) {
    return <></>;
  }
  if (!feedItem) {
    return <NotFound />;
  }

  return (
    <div className="flex flex-col space-y-1" style={{ zoom: zoom }}>
      <div className="w-full fixed top-0 bottom-[150px] overflow-y-scroll bg-gray-200">
        <div className="flex flex-col space-y-1">
          <div className="px-4 flex flex-col rounded-[4px] bg-white">
            <div className="py-4 flex items-start space-x-3">
              <img className="m-auto w-10 h-10" src={icAdsCommerce} alt="" />
              <div className="flex flex-col flex-grow items-start">
                <div
                  className="font-medium text-[15px] leading-[20px]"
                  style={{ color: "#0068FF" }}
                >
                  Tăng lượt liên hệ mua hàng trên Zalo
                </div>
                <div
                  className="font-normal text-[14px] leading-[18px]"
                  style={{ color: "#6F7071" }}
                >
                  Bài đăng sẽ được đưa đến những người có khả năng cao nhắn tin
                  cho bạn trên Zalo
                </div>
              </div>
            </div>
          </div>
          <Feed ecode={feedItem} />
          <FormCondition />
          <div
            className="px-4 py-5 flex flex-row justify-between bg-white rounded-[4px]"
            onClick={() => {
              navigate("/notice");
            }}
          >
            <div className="flex items-center font-medium text-[14px] leading-[18px]">
              Một số thông tin cần lưu ý
            </div>
            <IconInfo className="w-4 h-4" />
          </div>
        </div>
      </div>
      <div className="fixed bottom-0 w-full h-[150px]">
        <Separate />
        <div className="w-full px-4 py-4 flex flex-col space-y-4 ">
          <div className="flex flex-row justify-between">
            <div className="flex flex-col items-start">
              <div
                className="font-medium text-[15px] leading-[20px]"
                style={{ color: "#6F7071" }}
              >
                Tổng tiền
              </div>
              <div
                className="font-bold text-[16px] leading-[22px]"
                style={{ color: "#0D0D0D" }}
              >
                {formatCurrency(campaignInfo.totalCost)}
              </div>
            </div>
            <div
              className={`px-6 py-3 flex items-center rounded-[100px] font-medium text-[15px] leading-[20px] ${
                !isCompleted
                  ? "bg-gray-300 text-gray-500"
                  : "bg-blue-600 text-white"
              }`}
              onClick={handlePayment}
            >
              Quảng bá
            </div>
          </div>
          <div
            className="font-normal text-[12px] leading-[20px]"
            style={{ color: !isCompleted ? "#E05A00" : "#6F7071" }}
          >
            {!isCompleted
              ? "Bài đăng này đang được quảng bá. Không thể quảng bá thêm tại thời điểm này"
              : "Bằng cách nhấn vào Quảng bá, bạn đồng ý với Điều khoản và điều kiện của Zalo"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
